module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Add to Calendar","calendar-getToken":"Create my secured link","calendar-getLink":"Add Kipinto to my calendar"},"fr":{"title":"Ajouter au Calendrier","calendar-getToken":"Créer mon lien sécurisé","calendar-getLink":"Ajouter Kipinto à mon calendrier"}}')
  delete Component.options._Ctor
}
